<div class="title-box">
  <mat-icon *ngIf="icon" [svgIcon]="icon" class="square-icon title-icon"></mat-icon>
  <h3 class="title">{{ title }}</h3>
</div>

<div class="actions-box">
  <ng-content></ng-content>
</div>
